import { toBigInt } from "ethers";
import { safeParseUnits } from "./v3/unit";

export function sanitizeDecimalInput(raw, maxDecimals = 18) {
  // keep only digits and dots
  let v = raw.replace(/[^\d.]/g, "");

  // if multiple dots, keep the first only
  const firstDot = v.indexOf(".");
  if (firstDot !== -1) {
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
  }

  // limit decimals
  if (firstDot !== -1) {
    const [i, d = ""] = v.split(".");
    v = i + "." + d.slice(0, maxDecimals);
  }

  // normalize leading dots: "." -> "0."
  if (v.startsWith(".")) v = "0" + v;

  // avoid "00" style: "00012" -> "12" but keep "0" and "0.xxx"
  if (v.length > 1 && v[0] === "0" && v[1] !== ".") {
    v = v.replace(/^0+/, "");
    if (v === "") v = "0";
  }

  return v;
}

export const isPositiveAmount = (val, decimals) => {
  const bi = safeParseUnits(val, toBigInt(decimals));
  return bi !== null && bi > 0n;
};
